import { getAiInterviewsApi } from '../../api/AiInterviews/dashboard.api';
import { tryAsRecruiterApi } from '../../api/AiInterviews/tryTest.api';
import {
  bulkInviteCandidatesApi,
  bulkInviteStatusApi,
} from '../../api/AiInterviews/bulkInvite.api';
import {
  GET_AI_INTERVIEWS,
  GET_AI_INTERVIEWS_SUCCESS,
  BULK_INVITE_CANDIDATES,
  BULK_INVITE_STATUS,
  BULK_INVITE_CANDIDATES_SUCCESS,
  BULK_INVITE_CANDIDATES_FAILED,
  BULK_INVITE_STATUS_FINISH,
  GET_TRY_TEST_LINK,
  GET_TRY_TEST_LINK_FINISHED,
} from '../../constants/ActionTypes';
import { HTTP_STATUS_CODES } from '../../constants/HttpConstants';
import { errorHandler } from '../utils.saga';
import { call, put, takeLatest, select, delay } from 'redux-saga/effects';
import {
  IAiInterviewQueryParams,
  IAiInterviewsResponse,
  ITryTestLinkResponse,
} from '../../types/Interviews/aiInterview.types';
// TODO make showToast changes
import { showAlert } from '../../actions/alert.action';
import { showToast } from '../../actions/toast.action';
import { EToastVariant } from 'do-front-end-utils';
import { ITryTestLinkPayload } from '../../actions/AiInterviews/aiInterview.action';

/**
 * Get Ai Interviews Dashboard
 * @param {IPayload} data:IPayload
 * @returns {void}
 */
function* getAiInterviews(action: {
  type: string;
  payload: IAiInterviewQueryParams;
}): Generator {
  try {
    const getAiInterviewsResp: IAiInterviewsResponse = yield call(() =>
      getAiInterviewsApi(action.payload)
    );

    if (
      getAiInterviewsResp &&
      getAiInterviewsResp.status === HTTP_STATUS_CODES.OK &&
      getAiInterviewsResp?.data
    ) {
      yield put({
        type: GET_AI_INTERVIEWS_SUCCESS,
        payload: {
          interviewList: getAiInterviewsResp.data.objects[0].objects,
          meta: getAiInterviewsResp.data.objects[0].meta,
        },
      });
    } else {
      yield put(
        showToast({
          id: 'drd-ai-interview-empty-error',
          message: 'Failed to fetch AI interviews',
          variant: EToastVariant.ERROR,
        })
      );
    }
  } catch (err) {
    const message: string | null = yield call(errorHandler, err);
    if (message)
      yield put(
        showToast({
          id: 'drd-ai-interview-failed-error',
          message,
          variant: EToastVariant.ERROR,
        })
      );
  }
}

function* handleBulkInviteCandidates(action: any): Generator {
  try {
    const response = yield call(bulkInviteCandidatesApi, action.payload);
    if (response && response.status === HTTP_STATUS_CODES.OK) {
      yield put({
        type: BULK_INVITE_CANDIDATES_SUCCESS,
        payload: {
          bulkInviteInProgress: true,
          bulkTestSlug: action.payload.slug,
        },
      });
      if (action.payload.email_list.length === 1) {
        yield put(
          showToast({
            id: 'drd-ai-interview-invite-success',
            message: `Finished! - 1/1 invites sent and 0 failed`,
            variant: EToastVariant.INFO,
          })
        );
      } else {
        // Start polling
        yield put({
          type: BULK_INVITE_STATUS,
          payload: {
            bulkInviteStatusPolling: true,
          },
          meta: { id: response.data.invite_id },
        });
      }
    } else {
      yield put({
        type: BULK_INVITE_CANDIDATES_FAILED,
      });
      yield put(
        showToast({
          id: 'drd-ai-interview-invite-failed',
          message: `Bulk invite failed`,
          variant: EToastVariant.ERROR,
        })
      );
    }
  } catch (err) {
    yield put({
      type: BULK_INVITE_CANDIDATES_FAILED,
    });
    const message = yield call(errorHandler, err);
    if (message)
      yield put(
        showToast({
          id: 'drd-ai-interview-invite-failed',
          message: `Bulk invite failed`,
          variant: EToastVariant.ERROR,
        })
      );
  }
}

function* handleBulkInviteStatus(action: any): Generator {
  try {
    const { auth, bulkTestSlug } = yield select((state) => {
      return {
        auth: state.auth,
        bulkTestSlug: state.aiInterview?.bulkTestSlug,
      };
    });
    const id = auth.userIdentityData?.user_role_id;
    if (!id) return;

    const response = yield call(bulkInviteStatusApi, id);
    const { data, status } = response;

    if (
      status === HTTP_STATUS_CODES.OK &&
      data &&
      data.objects &&
      data.objects[bulkTestSlug]
    ) {
      // const testSlug = Object.keys(data.objects);
      const inviteStatusData = data.objects[bulkTestSlug];

      if (
        inviteStatusData.total_invites >
        inviteStatusData.failed_invites +
          inviteStatusData.process_invites +
          inviteStatusData.duplicate_emails +
          inviteStatusData.invalid_emails
      ) {
        yield put(
          showToast({
            id: 'drd-ai-interview-invite-in-progress',
            message: `Sending Invitations - ${inviteStatusData.process_invites} / ${inviteStatusData.total_invites} sent`,
            variant: EToastVariant.INFO,
          })
        );
        yield delay(10000);
        yield put({
          type: BULK_INVITE_STATUS,
        });
      } else {
        yield put(
          showToast({
            id: 'drd-ai-interview-invite-in-finished',
            message: `Finished! - ${inviteStatusData.process_invites}/${
              inviteStatusData.total_invites
            } invites sent and ${
              inviteStatusData.failed_invites +
              inviteStatusData.duplicate_emails +
              inviteStatusData.invalid_emails
            } failed`,
            variant: EToastVariant.INFO,
          })
        );
        yield put({
          type: BULK_INVITE_STATUS_FINISH,
        });
      }
    } else {
      yield put(
        showToast({
          id: 'drd-ai-interview-invite-status-failed',
          message: `Bulk status fetch failed`,
          variant: EToastVariant.ERROR,
        })
      );
      yield put({
        type: BULK_INVITE_STATUS_FINISH,
      });
    }
  } catch (error) {
    yield put(
      showToast({
        id: 'drd-ai-interview-invite-status-failed',
        message: `Bulk status fetch failed`,
        variant: EToastVariant.ERROR,
      })
    );
    yield put({
      type: BULK_INVITE_STATUS_FINISH,
    });
  }
}
function* getTryTestLink(action: ITryTestLinkPayload): Generator {
  try {
    const { slug } = action.payload || {};
    if (!slug) return;
    const response: ITryTestLinkResponse = yield call(() =>
      tryAsRecruiterApi(slug)
    );
    if (
      response &&
      response.status === HTTP_STATUS_CODES.OK &&
      response?.data?.access_url
    ) {
      yield call(() => window.open(response.data.access_url, '_blank'));
      yield put({ type: GET_TRY_TEST_LINK_FINISHED });
    } else {
      yield put(
        showToast({
          id: 'drd-ai-interview-try-interview-failed',
          message: `Try interview failed, please try again.`,
          variant: EToastVariant.ERROR,
        })
      );
      yield put({ type: GET_TRY_TEST_LINK_FINISHED });
    }
  } catch (err) {
    yield put(
      showToast({
        id: 'drd-ai-interview-try-interview-failed',
        message: `Try interview failed, please try again.`,
        variant: EToastVariant.ERROR,
      })
    );
    yield put({ type: GET_TRY_TEST_LINK_FINISHED });
  }
}
/**
 * Load AI Interviews
 * @returns {void}
 */
export default function* loadAiInterviews() {
  yield takeLatest(GET_AI_INTERVIEWS, getAiInterviews);
  yield takeLatest(GET_TRY_TEST_LINK, getTryTestLink);
  yield takeLatest(BULK_INVITE_CANDIDATES, handleBulkInviteCandidates);
  yield takeLatest(BULK_INVITE_STATUS, handleBulkInviteStatus);
}
